export default {
  path: 'solutions',
  name: 'Solutions',
};
